import React from "react";
import useMedia from "../../hooks/useMedia";

const Image = ({ image, className = "", alt = "", ...modifiers }) => {
  const media = useMedia();
  let classname = `${className} image`;
  classname = Object.keys(modifiers).reduce(
    (acc, modifier) => `${acc} -${modifier}`,
    classname
  );
  const size = media === "mobile" ? "xs" : "lg";
  const imageUrl =
    image && image.breakpoints
      ? image.base_path + image.breakpoints[size]["1x"]
      : image;

  const imageUrlx2 =
    image && image.breakpoints
      ? image.base_path + image.breakpoints[size]["2x"]
      : image;

  return (
    <img
      className={classname}
      src={imageUrl}
      alt={alt}
      srcSet={`${imageUrl} 1x,
${imageUrlx2} 2x`}
    />
  );
};

export default Image;
